import { useEffect, useState } from 'react';

export default function useVisibleSections(sectionIds = []) {
  const [visibleSections, setVisibleSections] = useState([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const currentlyVisible = [];

        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            currentlyVisible.push(entry.target.id);
          }
        });

        if (currentlyVisible.length > 0) {
          setVisibleSections(currentlyVisible);
        }
      },
      {
        root: null,
        threshold: 0.4, // Adjust for how much of the section should be visible
      }
    );

    sectionIds.forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return () => {
      observer.disconnect();
    };
  }, [sectionIds]);

  return visibleSections;
}
